// Catalogo Pacchetti Mobility Safe
// Definizione coperture per ogni pacchetto

export const PACKAGE_TYPES = {
  Base: "Base",
  Medium: "Medium",
  Collisione: "Collisione",
  Kasko: "Kasko"
};

export const packageCatalog = {
  Base: {
    id: "Base",
    name: "Base",
    color: "#2196F3", // Blu
    bgColor: "#E3F2FD",
    icon: "Shield",
    description: "Protezione essenziale per il tuo veicolo",
    coverages: [
      { id: "valore_nuovo", name: "Valore a nuovo", description: "Rimborso al valore di acquisto per 24 mesi", limit: "24 mesi" },
      { id: "incendio", name: "Incendio", description: "Danni da incendio, esplosione, scoppio" },
      { id: "furto", name: "Furto totale e parziale", description: "Furto, rapina, tentativo di furto" },
      { id: "ricorso_terzi", name: "Ricorso terzi da incendio", description: "Danni a terzi causati da incendio del veicolo" },
      { id: "cristalli", name: "Rottura cristalli", description: "Parabrezza, lunotto e cristalli laterali" },
      { id: "accessori", name: "Pacchetto accessori", description: "Accessori originali e aftermarket dichiarati" }
    ]
  },
  Medium: {
    id: "Medium",
    name: "Medio",
    color: "#FF9800", // Arancione
    bgColor: "#FFF3E0",
    icon: "ShieldCheck",
    description: "Protezione estesa con garanzie aggiuntive",
    includes: "Base",
    additionalCoverages: [
      { id: "eventi_naturali", name: "Eventi naturali", description: "Grandine, alluvione, terremoto, frana", limit: "€6.000/sinistro" },
      { id: "vandalismo", name: "Atti vandalici", description: "Danni da vandalismo e atti dolosi", limit: "€6.000/sinistro" },
      { id: "animali", name: "Collisione animali selvatici", description: "Urto con fauna selvatica", limit: "€3.000/anno" }
    ]
  },
  Collisione: {
    id: "Collisione",
    name: "Collisione",
    color: "#4CAF50", // Verde
    bgColor: "#E8F5E9",
    icon: "ShieldPlus",
    description: "Include danni da collisione con altri veicoli",
    includes: "Medium",
    additionalCoverages: [
      { id: "collisione", name: "Collisione", description: "Danni da urto con veicoli identificati" }
    ]
  },
  Kasko: {
    id: "Kasko",
    name: "Kasko",
    color: "#9C27B0", // Viola
    bgColor: "#F3E5F5",
    icon: "ShieldAlert",
    description: "Massima protezione - Danni propri inclusi",
    includes: "Medium",
    additionalCoverages: [
      { id: "kasko", name: "Kasko", description: "Tutti i danni propri, inclusa uscita di strada" }
    ]
  }
};

// Ottieni tutte le coperture per un pacchetto (incluse quelle ereditate)
export const getAllCoverages = (packageType) => {
  const pkg = packageCatalog[packageType];
  if (!pkg) return [];
  
  let coverages = [...(pkg.coverages || [])];
  
  // Aggiungi coperture ereditate
  if (pkg.includes) {
    const parentCoverages = getAllCoverages(pkg.includes);
    coverages = [...parentCoverages, ...(pkg.additionalCoverages || [])];
  } else {
    coverages = [...(pkg.coverages || [])];
  }
  
  return coverages;
};

// Ottieni solo le coperture aggiuntive rispetto al pacchetto base
export const getAdditionalCoverages = (packageType) => {
  const pkg = packageCatalog[packageType];
  return pkg?.additionalCoverages || [];
};